import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ProfileService } from '@core/services/profile.service';
import { ToastService } from '../../services/toast.service';
import { USER_ROLES } from '@shared/constant/shared.constant';
import { autoUnsubWith } from '@shared/services/utility.abstract';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';

@Component({
  selector: 'app-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.scss']
})
export class DeleteModalComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  bodyText = '';
  headerText = '';
  role : string ='';
  userRoles = USER_ROLES;
  isForceFully: boolean;
  
  constructor(private readonly router: Router,
    public readonly ref: DynamicDialogRef,
    public readonly config: DynamicDialogConfig,
    private readonly service: ProfileService,
    private readonly toastService: ToastService,
    private readonly encryptStorage: EncryptionStorageService) { }

  ngOnInit(): void {
    this.role = this.encryptStorage.getItem('roleName');
    this.bodyText = this.config.data.bodyText;
    this.headerText = this.config?.data?.headerText;
    this.isForceFully = this.config?.data?.isForceFully ?? false;
  }

  continue(): void {
    this.ref.close();
    let navigationFromViewUrl = this.encryptStorage.getItem('navigationFromView');
    if (!navigationFromViewUrl)
      if(this.role === this.userRoles.DRIVER)
        {
          navigationFromViewUrl = 'driver/profile';
        }
        else{
      navigationFromViewUrl = 'manager/profile';
        }

    this.router.navigateByUrl(navigationFromViewUrl);
  }

  deactivateAccount() {
    this.service.deleteUserAccount()
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: ((res:any) => {
          this.toastService.showToastMessage('success', 'Success', res.message);
        this.ref.close();
        setTimeout(() => {
          this.router.navigate(['login']);
        }, 1200);
      }),
      error: ((error) => {
        this.toastService.showToastMessage('error', 'Error', error.error.message)
      })
    })
  }

}
